import React from "react";

const NonTVImg = ({ content }) => {
  return (
    <div
      className="non-tv-img-scaler"
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div style={{}}>
        <p
          style={{
            width: "460px",
            position: "relative",
            top: content.text_top,
            transformOrigin: "top left",
            right: parseInt(content.right) + 10 + "px",
            fontSize: "48px",
            color: "#c20839",
            fontFamily: "LG_Smart_Bold",
            textAlign: "right",
          }}
        >
          {content.text}
        </p>
      </div>
      <img
        src={content.src}
        width={content.width}
        style={{
          position: "relative",
          top: "40px",
          right: content.right,
          transformOrigin: "top left",
        }}
      />
    </div>
  );
};

export default NonTVImg;
